import React from "react";

export default function DocumentRequestFormSkeletton() {
  return (
    <div className="flex flex-col gap-4">
      <div className="animate-pulse">
        <div className="h-5 w-16 mb-1 bg-gray-300 rounded" />
        <div className="flex flex-col gap-2">
          {Array(2)
            .fill(0)
            .map((_, index) => (
              <div key={index} className="flex items-center gap-4">
                <div className="flex-initial h-7 w-7 bg-gray-300 rounded-full" />
                <div className="h-5 w-32 bg-gray-300 rounded" />
              </div>
            ))}
        </div>
      </div>
      {Array(3)
        .fill(0)
        .map((_, index) => {
          return (
            <div key={index} className="animate-pulse">
              <div className="h-5 w-16 mb-1 bg-gray-300 rounded" />
              <div className="h-14 w-full bg-gray-300 border border-gray-300 rounded" />
            </div>
          );
        })}
      <div className="flex items-center gap-4 animate-pulse">
        <div className="flex-initial h-7 w-7 bg-gray-300 rounded" />
        <div className="flex-1 flex flex-col gap-1">
          <div className="h-5 w-full bg-gray-300 rounded" />
          <div className="h-5 w-1/3 bg-gray-300 rounded" />
        </div>
      </div>
      <div className="h-5 w-2/3 bg-gray-300 rounded" />
    </div>
  );
}
